import type { FC } from "react";
import { ColorSwatch } from "@smartfaster-ui/components";
import type { RalColorEntry } from "../context/types";
import { OptionGroup } from "./OptionGroup";

type ColorSwatchGridProps = {
  options: RalColorEntry[];
  value: string | null;
  onValueChange: ({ value }: { value: string | null }) => void;
};

export const ColorSwatchGrid: FC<ColorSwatchGridProps> = ({
  options,
  value,
  onValueChange,
}) => {
  return (
    <OptionGroup
      options={options.map((option) => ({
        id: option.id,
        label: option.label_nl,
        leading: <ColorSwatch color={option.hex} size="md" />,
      }))}
      value={value}
      onValueChange={onValueChange}
    />
  );
};
